import { CalculatorLineItem } from '@/modules/tax/models/calculators/CalculatorLineItem';
import { Calculator } from '@/modules/tax/models/calculators/Calculator';

export class ProbateBondCalculator extends Calculator {
  lineItems: Relationship<CalculatorLineItem[]> | null;

  constructor(model: Partial<ProbateBondCalculator> = {}) {
    super(model);

    this.lineItems = CalculatorLineItem.mapModelsOrNull(model.lineItems);
  }
}
